export default {
  'not-found': 'Página não encontrada',
  'internal-error': 'Incapaz de processar o pedido',
  'preview-error':
    '<strong>O slug do artigo não é válido</strong>.<br/> Verifique se o campo do slug está preenchido e se o artigo foi <strong>Publicado</strong> ou <strong>salvo como Rascunho</strong>.',
  continue: 'Continue a navegação',
}
